module.exports = __webpack_public_path__ + "static/flags/CF-bae8736be94d848edf46c5f93cbea4f9.gif";